import { Entry, RichTextContent } from 'contentful'
import { GenericContentBlock } from 'types/contentful/genericContentBlock'
import { Heading } from './Heading'
import { Teams } from './Teams'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { Button } from '@noissue-ui-kit/oldBranding/button'

interface IOurTeam {
  teamSectionHeading: string
  teamSectionDescription: RichTextContent
  teamList: Entry<GenericContentBlock>[]
  teamButtonLink: string
  teamButtonLabel: string
}

export function OurTeam({
  teamSectionHeading,
  teamSectionDescription,
  teamList,
  teamButtonLink,
  teamButtonLabel,
}: IOurTeam) {
  const transformedTeamList = teamList?.map((team) => ({
    title: team.fields.h1,
    image: mapContentfulImageAsset(team?.fields?.primaryImages?.[0]),
  }))

  return (
    <div
      id="team"
      className="scroll-mt-[90px] relative w-full px-6 bg-white pt-14 md:px-8 md:pt-28 xl:px-0 xl:pt-24"
    >
      <div className="max-w-[1186px] mx-auto relative text-center bg-white rounded-md md:shadow-[0_12px_33px_0_rgba(0,0,0,0.1)]">
        <div className="w-[134px] h-[139px] absolute hidden bg-contain -bottom-0 -right-0 md:block bg-[url('/aboutus/page-curl.png')] bg-no-repeat"></div>
        <Heading
          teamSectionHeading={teamSectionHeading}
          teamSectionDescription={teamSectionDescription}
        />
        <Teams teamList={transformedTeamList} />
        <div className="flex justify-center pt-24 pb-28">
          <Button
            Component="a"
            corners="square"
            href={teamButtonLink}
            size="m"
            variant="primary"
            className="min-w-[250px]"
          >
            {teamButtonLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
